module.exports = __webpack_public_path__ + "static/media/ic_mada.0f159a79.svg";